<div class="animated fadeIn">
<h3>Admin Panel</h3>
                <br/>

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">View Report Details</h4>
             <a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="backfile()">Back</a>
              <br/>
              <ul id="sheetCont">
                   <li class="btn btn-info" style="float: left;margin-right: 5px;" *ngIf="showDownload" >
                        <a  href="{{downLoadPath}}report/{{fileName}}" style="color:#000 !important;">Report Download</a> 
                    </li>
               </ul>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info" [innerHTML]="safeHtml">
                                            
                                        
                                        </table>
            </div>
        </div>
       

</div>
</div><!-- .animated -->

